import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Helmet from 'react-helmet';
export default function Page({ title, children }) {
    return (_jsxs(_Fragment, { children: [title && (_jsx(Helmet, { children: _jsx("title", { children: title }) })), children] }));
}
